// Import styles
import '../styles/filter_layers_icons'
import '../styles/map'
import '../styles/feeling'// TODO move

//-----------------------------------------------------------------------------

import 'jquery';
import $ from 'jquery';

import toastr from 'toastr';
toastr.options = {
    "closeButton": false,
    "debug": false,
    "newestOnTop": false,
    "progressBar": true,
    "positionClass": "toast-top-right",
    "preventDuplicates": true,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
};
window.toastr = toastr;

//-----------------------------------------------------------------------------

const elementIDs = {
    layerFilterPanel: "et-maps-filters-layer",
    dateFilterPanel: "et-maps-filters-date",
    layersPanel: "et-maps-layers",
    layerDetailPanel: "et-maps-layer-detail",
    layerFilterButton: "et-maps-layer-filter-button",
    dateFilterButton: "et-maps-date-filter-button",
    
    detailPanel: "et-feeling-detail",
    position: 'et-feeling-position',
    
    map: "map"
};

let maps = null;

function formatPoint(point) {
    if (point) {
        return point.lat.toFixed(7) + ", " + point.lng.toFixed(7);
    }

    return maps.i18n.unknown_position;
}

function refreshCurrentPoint(point, lngLat) {
    maps.point = lngLat;

    let features = maps.map.queryRenderedFeatures(point);
    
    LayersPanel.navigateDisplayFeatures(features);
    
    let position = document.getElementById(elementIDs.position);
    if (position) {
        position.innerText = formatPoint(lngLat);
    }
}

//-----------------------------------------------------------------------------

// Controls
//-----------------------------------------------------------------------------
// Feelinig welcome control
class FeelingWelcomeControl {
    constructor(result = null) {
        this.result = result;
        this.detailPanel = document.getElementById(elementIDs.detailPanel);
        
        this.build();
    }
    
    build() {
        if (!this.detailPanel) {
            return;
        }

        this.detailPanel.innerHTML = '';
        
        let title = maps.i18n.add_title;
        let text = maps.i18n.add_text;
        let buttonText = maps.i18n.add_button;
        if (this.result === true) {
            title = maps.i18n.thanks_title;
            text = maps.i18n.thanks_text;
            buttonText = maps.i18n.thanks_add;
        } else if (this.result === false) {
            title = maps.i18n.error_title;
            text = maps.i18n.error_text;
            buttonText = maps.i18n.error_add;
        }

        this.titleElement = DomHelper.addElement('div', title, this.detailPanel, {class: 'et-maps-info-panel-body-section-title'});
        
        let parent = DomHelper.addElement('div', null, this.detailPanel, {class: 'row'});
        this.textElement = DomHelper.addElement('p', text, parent, {class: ''} );

        this.addButtonElement = DomHelper.addElement('button', buttonText, this.detailPanel, { 'id': 'et-feeling-button-add', class: 'btn' });

        $(document).off('click', '#et-feeling-button-add', this.addButtonClick).on('click', '#et-feeling-button-add', this.addButtonClick);
    }

    addButtonClick() {
        maps.control = new FeelingSelectControl();
    }
}

//-----------------------------------------------------------------------------

// Feelinig select control
class FeelingSelectControl {
    constructor() {
        this.detailPanel = document.getElementById(elementIDs.detailPanel);
        const jwt_token = document.querySelector('head meta[name="jwt-token"]').content;
        
        let self = this;
        $.ajax({
            url: `${maps.apiFeelingTypesUrl}&jwt_token=${jwt_token}`,
            type: 'GET',
            dataType: 'json',
            success: function(response) {
                self.feelingTypes = response;
                self.availableFeelingTypes = 0;
                for (let i = 0; i < self.feelingTypes.length; i++) {
                    let ft = self.feelingTypes[i];
                    if (ft.freeVoteCount > 0) {
                        self.availableFeelingTypes++;
                    }
                }
                
                self.build();
            },
            error: function (request, status, error) {
                toastr["warning"](maps.i18n.log_in);
            }
        });
    }

    build() {
        this.detailPanel.innerHTML = '';

        DomHelper.addElement('div', maps.i18n.select_title, this.detailPanel, {class: 'et-maps-info-panel-body-section-title'});
        
        if (this.availableFeelingTypes > 0) {
            this.addFeelingTypes();
            
            let parent = DomHelper.addElement('div', null, this.detailPanel, {class: 'row'});
            DomHelper.addElement('p', maps.i18n.select_position_title, parent, {class: 'et-maps-info-panel-body-section-label'} );
            DomHelper.addElement('label', formatPoint(maps.point), parent, { id: elementIDs.position, class: 'et-feeling-panel-body-position'} );

            parent = DomHelper.addElement('div', null, this.detailPanel, {class: 'row'});
            DomHelper.addElement('p', maps.i18n.select_comment_placeholder, parent, {class: 'et-maps-info-panel-body-section-label'} );
            DomHelper.addElement('textarea', null, parent, {
                id: 'et-feeling-description',
                name: 'description',
                //placeholder: maps.i18n.select_comment_placeholder,
                class: 'materialize-textarea',
                style: 'height: 6rem; padding-top:0px; max-height: 6rem; overflow-y: auto; resize: none'
            });
            
            this.addButtonElement = DomHelper.addElement('button', maps.i18n.send_button, this.detailPanel, { id: 'et-feeling-button-send', class: 'btn' });
            $(document).off('click', '#et-feeling-button-send').on('click', '#et-feeling-button-send', this.sendButtonClick);
        } else {
            let parent = DomHelper.addElement('div', null, this.detailPanel, {class: 'row'});
            DomHelper.addElement('p', maps.i18n.select_no_available_feeling_types, parent, {class: ''});
            this.addButtonElement = DomHelper.addElement('button', maps.i18n.send_button_ok, this.detailPanel, { id: 'et-feeling-button-send', class: 'btn' });
            $(document).off('click', '#et-feeling-button-send').on('click', '#et-feeling-button-send', this.sendButtonClick);
        }
    }

    addFeelingTypes() {
        let parent = DomHelper.addElement('div', null, this.detailPanel, {class: 'row'});
        DomHelper.addElement('p', maps.i18n.select_type_title, parent, {class: 'et-maps-info-panel-body-section-label'} );
        for (let i = 0; i < this.feelingTypes.length; i++) {
            let ft = this.feelingTypes[i];

            let disabled = '';
            let spanClass = 'et-feeling-radio-enabled';
            if (ft.freeVoteCount <= 0) {
                disabled = "disabled='disabled'";
                spanClass = '';
            }
            
            let content = `
            <label>
                <input name='feelingTypeId' type='radio' ` + disabled + ` value='` + ft.id + `' />
                <span class='et-feeling-radio ` + spanClass + `' style='--radio-color:` + ft.color + `;'>` + ft.name + " " + ft.freeVoteCount + "/" + ft.maxVoteCount +`</span>
            </label>`;
            DomHelper.addElement('p', content, parent);
        }
    }
    
    sendButtonClick() {
        if (maps.control.availableFeelingTypes > 0) {
            const csrf_token = document.querySelector('head meta[name="csrf-token"]').content;
            const jwt_token = document.querySelector('head meta[name="jwt-token"]').content;

            let checkedRadio = document.querySelector('input[name="feelingTypeId"]:checked');
            let point = maps.point;
            
            if (!checkedRadio || !maps.point) {
                return;
            }
            
            let data = {
                authenticity_token: csrf_token,
                jwt_token: jwt_token,
                feelingTypeId: checkedRadio.value,
                description: document.getElementById('et-feeling-description').value,
                latitude: point.lat,
                longitude: point.lng,
            };
            
            $.post(maps.apiAddFeelingUrl, data)
            .done(function(msg){
                maps.control = new FeelingWelcomeControl(true);
            })
            .fail(function(xhr, status, error) {
                maps.control = new FeelingWelcomeControl(false);
            });
        } else {
            maps.control = new FeelingWelcomeControl();
        }
    }
}

//-----------------------------------------------------------------------------

class DomHelper {
    static addElement(name, content = null, parent = null, attributes = null) {
        let element = document.createElement(name);

        if (content) {
            element.innerHTML = content;
        }

        if (parent) {
            parent.appendChild(element);
        }
        
        if (attributes) {
            for (var key in attributes) {
                element.setAttribute(key, attributes[key]);
            }
        }

        return element;
    }

    static addRating(ratingValue, leftText, rightText, parent) {
        if (parent) {
            let rating = DomHelper.addElement('div', null, parent, {class: 'et-maps-panel-layer-rating'});
            
            if (leftText) {
                DomHelper.addElement('span', `${leftText}`, rating, {class: 'et-maps-panel-layer-rating-left-text'});
            }
            
            for (let i = 0; i < 5; i++) {
                if (ratingValue > i + 0.5) {
                    DomHelper.addElement('i', "star", rating, {class: 'material-icons rating-color'});
                } else if (ratingValue > i) {
                    DomHelper.addElement('i', "star_half", rating, {class: 'material-icons rating-color'});
                } else {
                    DomHelper.addElement('i', "star_border", rating, {class: 'material-icons rating-color'});
                }
            }

            if (rightText) {
                DomHelper.addElement('span', `${rightText}`, rating, {class: 'et-maps-panel-layer-rating-right-text'});
            }
        }
    }
}

//-----------------------------------------------------------------------------

// Panel that contains basic information about all items in the layer.
class LayersPanel {
    constructor() {
        this.element = document.getElementById(elementIDs.layersPanel);
        this.listElement = null;
        this.closeButton = null;
        this.features = null;
        
        this.build();
    }
    
    build() {
        if (!this.element) {
            return;
        }
        
        this.element.innerHTML = '';
        
        this.addHeader();
        this.addListContainer();
    }

    exists() {
        let result = (document.getElementById(elementIDs.layersPanel) != null);
        return result;
    }

    show() {
        $(`#${elementIDs.layersPanel}`).show();
    }
    
    hide() {
        $(`#${elementIDs.layersPanel}`).hide();
    }

    displayFeatures (features) {
        this.features = features;
        
        this.listElement.innerHTML = '';
        
        if (features && features.length) {
            // Create list of elements.
            this.features.forEach((element, index) => {
                let etGuid = element.properties["etguid"];
                let etTitle = element.properties["ettitle"];
                
                let item = DomHelper.addElement('li', null, this.listElement, {id: `item-${etGuid}`, class: 'et-maps-panel-layer-list-item', 'data-id': `${etGuid}`});
                let header = DomHelper.addElement('div', null, item, {id: `item-header-${etGuid}`, class: 'et-maps-panel-layer-list-item-header'});
                DomHelper.addElement('div', etTitle, header, {class: 'et-maps-panel-layer-list-item-header-title'});
            });

            $(document).off('click', '.et-maps-panel-layer-list-item', LayersPanel.itemClick).on('click', '.et-maps-panel-layer-list-item', LayersPanel.itemClick);

            // Call rating info api and generate rating.
            let self = this;
            this.features.forEach((element, index) => {
                let etGuid = element.properties["etguid"];
                if (maps.apiRatingsInfoUrl) {
                    $.get(maps.apiRatingsInfoUrl, { guid: etGuid }, function(data) {
                        let itemId = `#item-header-${data.guid}`;
                        let itemElement = $(itemId)[0];
                        
                        let ratingValue = data.avgRating.toFixed(1);
                        let leftText = `${ ratingValue }`;
                        let rightText = `(${ data.count })`;
                        DomHelper.addRating(ratingValue, leftText, rightText, itemElement);
                    });
                }
            });

            maps.layerDetailPanel.hide();
            this.show();
        } else {
            if (maps.layerDetailPanel.isVisible()) {
                maps.layerDetailPanel.hide();
                this.show();
            }
        }
    }

    closeButtonClick(e) {
        maps.layersPanel.hide();
    }

    navigateDetail(etGuid) {
        this.features.forEach((feature, index) => {
            let elementEtGuid = feature.properties["etguid"];
            if (etGuid == `${elementEtGuid}`) {
                this.hide();
                LayerDetailPanel.navigateDisplayFeature(feature);
            }
        });
    }

    addHeader() {
        let header = DomHelper.addElement('div', null, this.element, {class: 'et-maps-panel-header'});
        // this.backButton = DomHelper.addElement('div', null, header, {class: 'et-maps-panel-header-back-button'});
        // DomHelper.addElement('i', 'arrow_back', this.backButton, {class: 'material-icons'});
        
        DomHelper.addElement('div', maps.i18n.layers_panel_title, header, {class: 'et-maps-panel-header-title'});

        this.closeButton = DomHelper.addElement('div', null, header, {class: 'et-maps-panel-header-close-button'});
        DomHelper.addElement('i', 'close', this.closeButton, {class: 'material-icons'});

        this.closeButton.addEventListener("click", this.closeButtonClick);
    }

    addListContainer() {
        let parent = DomHelper.addElement('div', null, this.element, {class: 'et-maps-panel-body'});
        this.listElement = DomHelper.addElement('ul', null, parent, {class: 'et-maps-panel-layer-list'});
    }

    static itemClick(e) {
        let etGuid = $(this).attr('data-id');
        maps.layersPanel.navigateDetail(etGuid);
    }

    static navigateDisplayFeatures(features) {
        if (maps.layersPanel != null && maps.layersPanel.exists()) {
            let guidFeatures = LayersPanel.filterKnownFeatures(features);
            maps.layersPanel.displayFeatures(guidFeatures);
        }
    }

    // Returns only features that contains et-guid.
    static filterKnownFeatures(features) {
        let usedGuids = new Set();
        // Unique features
        let guidFeatures = [];
        for (let i = 0; i < features.length; i++) {
            let feature = features[i];
            if (feature.properties.etguid != null && !usedGuids.has(feature.properties.etguid)) {
                guidFeatures.push(feature);
                usedGuids.add(feature.properties.etguid);
            }
        }
        guidFeatures.sort((a, b) => a.properties.ettitle.localeCompare(b.properties.ettitle));

        return guidFeatures;
    }
}

//-----------------------------------------------------------------------------

// Panel that contains detail information about selected layer.
class LayerDetailPanel {
    constructor() {
        this.element = document.getElementById(elementIDs.layerDetailPanel);
        this.bodyElement = null;
        this.ratingElement = null;
        this.ratingListElement = null;
        this.backButton = null;
        this.closeButton = null;
        this.features = null;
        
        this.build();
    }
    
    build() {
        if (!this.element) {
            return;
        }
        
        this.element.innerHTML = '';
        
        this.addHeader();
        this.addBodyContainer();
        if (maps.apiRatingsUrl) {
            this.addRatingContainer();
        }
    }
    
    isVisible() {
        return $(`#${elementIDs.layerDetailPanel}`).is(":visible");
    }
    
    
    show() {
        $(`#${elementIDs.layerDetailPanel}`).show();
    }
    
    hide() {
        $(`#${elementIDs.layerDetailPanel}`).hide();
    }

    displayFeature(feature) {
        this.feature = feature;
        let etTitle = feature.properties.ettitle;
        let etText = feature.properties.ettext;

        this.layerInfo.innerHTML = '';
        // Title and description.
        DomHelper.addElement('div', etTitle, this.layerInfo, {class: 'et-maps-panel-body-title'});
        DomHelper.addElement('div', etText, this.layerInfo, {class: 'et-maps-panel-body-description'});
        // console.log(feature.properties);
        // Properties
        if (maps.properties != null) {
            for (const [propertyName, propertyTitle] of Object.entries(maps.properties)) {
                if (Object.prototype.hasOwnProperty.call(feature.properties, propertyName)) {
                    let propertyValue = feature.properties[propertyName];
                    if (propertyValue != null) {
                        if (propertyName == 'web') {
                            propertyValue = `<a href="${propertyValue}" target="_blank">${propertyValue}</a>`;
                        } else if (propertyName == 'email') {
                            propertyValue = `<a href="mailto:${propertyValue}">${propertyValue}</a>`;
                        }
                        
                        DomHelper.addElement('div', `<b>${propertyTitle}:</b> ${propertyValue}`, this.layerInfo, {class: 'et-maps-panel-body-parameter'});
                    }
                }
            }
        }
        
        // Rating form
        if (maps.apiRatingsUrl) {
            this.addRatingForm();
            this.loadRatings();
        }
        this.show();
    }
    
    backButtonClick(e) {
        maps.layerDetailPanel.hide();
        maps.layersPanel.show();
    }
    
    closeButtonClick(e) {
        maps.layerDetailPanel.hide();
    }

    addHeader() {
        let header = DomHelper.addElement('div', null, this.element, {class: 'et-maps-panel-header'});
        this.backButton = DomHelper.addElement('div', null, header, {class: 'et-maps-panel-header-back-button'});
        DomHelper.addElement('i', 'arrow_back', this.backButton, {class: 'material-icons'});
        
        DomHelper.addElement('div', maps.i18n.layer_detail_panel_title, header, {class: 'et-maps-panel-header-title'});

        this.closeButton = DomHelper.addElement('div', null, header, {class: 'et-maps-panel-header-close-button'});
        DomHelper.addElement('i', 'close', this.closeButton, {class: 'material-icons'});

        this.backButton.addEventListener("click", this.backButtonClick);
        this.closeButton.addEventListener("click", this.closeButtonClick);
    }
    
    addBodyContainer() {
        this.bodyElement = DomHelper.addElement('div', null, this.element, {class: 'et-maps-panel-body'});
        this.layerInfo = DomHelper.addElement('div', null, this.bodyElement, {class: 'et-maps-panel-body-info'});
    }
    
    addRatingContainer() {
        this.ratingElement = DomHelper.addElement('div', null, this.bodyElement, {class: 'et-maps-panel-rating-form'});
        this.ratingListElement = DomHelper.addElement('div', null, this.bodyElement, {class: 'et-maps-panel-rating-list'});
    }

    setRatingMessage(message, append = false) {
        if (!append) {
            this.ratingElement.innerHTML = '';
        }
        DomHelper.addElement('p', message, this.ratingElement, {class: 'et-maps-panel-rating-form-message'});
    }

    addRatingForm(message = null) {
        let etGuid = this.feature.properties.etguid;

        let jwtToken = document.querySelector('head meta[name="jwt-token"]');
        if (jwtToken && jwtToken.content) {
            this.ratingElement.innerHTML = '';
            DomHelper.addElement('p', maps.i18n.select_comment_title, this.ratingElement, {id: 'et-maps-rating', class: 'et-maps-panel-rating-form-title', 'data-id': etGuid} );
            let parent = DomHelper.addElement('div', null, this.ratingElement);
            parent.innerHTML =
                `<div class="rating">
                    <input type="radio" id="star5" name="rating" value="5" /><label for="star5"></label>
                    <input type="radio" id="star4" name="rating" value="4" /><label for="star4"></label>
                    <input type="radio" id="star3" name="rating" value="3" /><label for="star3"></label>
                    <input type="radio" id="star2" name="rating" value="2" /><label for="star2"></label>
                    <input type="radio" id="star1" name="rating" value="1" /><label for="star1"></label>
                </div>`;
            
            DomHelper.addElement('p', maps.i18n.select_comment_placeholder, this.ratingElement, {class: 'et-maps-panel-rating-form-label'} );
            DomHelper.addElement('textarea', null, this.ratingElement, {
                id: 'et-rating-description',
                name: 'description',
                maxlength: '400',
                //placeholder: maps.i18n.select_comment_placeholder,
                class: 'materialize-textarea',
                style: 'height: 6rem; padding-top:0px; max-height: 6rem; overflow-y: auto; resize: none'
            });
            
            if (message) {
                DomHelper.addElement('p', message, this.ratingElement, {class: 'et-maps-panel-rating-form-label'} );
            }

            this.addButtonElement = DomHelper.addElement('button', maps.i18n.send_button, this.ratingElement, { id: 'et-rating-button-send', class: 'btn' });
            $(document).off('click', '#et-rating-button-send').on('click', '#et-rating-button-send', this.sendButtonClick);
        } else {
            this.setRatingMessage(maps.i18n.log_in);
        }
    }
    
    loadRatings() {
        // Rating list
        let self = this;
        self.ratingListElement.innerHTML = '';
        if (maps.apiRatingsUrl) {
            $.get(maps.apiRatingsUrl, { guid: this.feature.properties.etguid, limit: 1000 }, function(data) {
                self.ratingListElement.innerHTML = '';
                if (data.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        let listItem = DomHelper.addElement('div', null, self.ratingListElement, {class: 'et-maps-panel-rating-list-item'});
                        let ratingValue = data[i].rating.toFixed(1);
                        let rightText = data[i].createdAtText;
                        DomHelper.addRating(ratingValue, null, rightText, listItem);
                        DomHelper.addElement('p', data[i].description, listItem);
                    }
                } else {
                    DomHelper.addElement('p', maps.i18n.object_not_rated, self.ratingListElement, {class: 'et-maps-panel-rating-list-message'});
                }
            });
        }
    }

    sendButtonClick() {
        if (maps.layerDetailPanel) {
            const csrf_token = document.querySelector('head meta[name="csrf-token"]').content;
            const jwt_token = document.querySelector('head meta[name="jwt-token"]').content;
            const guid = document.querySelector('#et-maps-rating').getAttribute('data-id');
            
            let checkedRadio = document.querySelector('input[name="rating"]:checked');
            
            if (!checkedRadio) {
                return;
            }
            
            let data = {
                authenticity_token: csrf_token,
                jwt_token: jwt_token,
                guid: guid,
                rating: checkedRadio.value,
                languag: "cs",
                description: document.getElementById('et-rating-description').value
            };
            
            $.post(maps.apiAddRatingUrl, data)
            .done(function(msg){
                maps.layerDetailPanel.loadRatings();
                maps.layerDetailPanel.addRatingForm(maps.i18n.rating_thanks_title);
                //toastr["success"](maps.i18n.rating_thanks_title);
            })
            .fail(function(xhr, status, error) {
                toastr["warning"](maps.i18n.log_in);
            });
        }
    }

    static navigateDisplayFeature(feature) {
        maps.layerDetailPanel.displayFeature(feature);
        maps.layerDetailPanel.show();
    }
}

//-----------------------------------------------------------------------------

// Panel that displayes filter with date ranges.
class DateFilterPanel {
    constructor() {
        this.element = document.getElementById(elementIDs.dateFilterPanel);
        
        this.build();
    }
    
    build() {
        // If the element is not defined, hide the filter button.
        if (!this.element) {
            $(`#${elementIDs.dateFilterButton}`).hide();
            return;
        }
        
        // Filters for this map are not available.
        this.defaultStyle = maps.style;
        this.filters = this.getFilters();
        if (!this.filters || !this.filters.options || this.filters.options.length == 0) {
            $(`#${elementIDs.dateFilterButton}`).hide();
            return;
        }
        
        $(`#${elementIDs.dateFilterButton}`).show();
        this.element.innerHTML = '';
        this.addHeader();
        this.addFilters();

        // Hook on the filter button.
        $(document).off('click', `#${elementIDs.dateFilterButton}`).on('click', `#${elementIDs.dateFilterButton}`, this.filterButtonClick);
    }

    show() {
        $(`#${elementIDs.dateFilterPanel}`).show();
    }
    
    hide() {
        $(`#${elementIDs.dateFilterPanel}`).hide();
    }
    
    closeButtonClick(e) {
        maps.dateFilterPanel.hide();
    }

    addHeader() {
        let header = DomHelper.addElement('div', null, this.element, {class: 'et-maps-panel-header'});
        
        DomHelper.addElement('div', maps.i18n.date_filter_panel_title, header, {class: 'et-maps-panel-header-title'});
        
        this.closeButton = DomHelper.addElement('div', null, header, {class: 'et-maps-panel-header-close-button'});
        DomHelper.addElement('i', 'close', this.closeButton, {class: 'material-icons'});

        this.closeButton.addEventListener("click", this.closeButtonClick);
    }

    addFilters() {
        let defautStyleFileName = this.defaultStyle.substring(this.defaultStyle.lastIndexOf('/') + 1);
        
        let body = DomHelper.addElement('div', null, this.element, {class: 'et-maps-panel-body'});
        let parent = DomHelper.addElement('ul', null, body, {class: 'et-maps-panel-filter-list'});
        for(let i = 0; i < this.filters.options.length; i++) {
            let filter = this.filters.options[i];
            let styleFileName = filter["option-value"].substring(filter["option-value"].lastIndexOf('/') + 1);
            let isDefaultStyle = (styleFileName == defautStyleFileName);
            
            let checkBoxData = {
                id: `et-maps-date-filter-date-${i}`,
                name: "et-maps-date-filter-date",
                type: "radio", value: filter["option-value"]
            };
            
            if (isDefaultStyle) {
                checkBoxData.checked = 'checked';
            }
            
            let li = DomHelper.addElement('li', null, parent, {class: 'et-maps-panel-filter-list-item'});
            DomHelper.addElement('label', filter["option-title"], li, {for: `et-maps-date-filter-date-${i}`});
            DomHelper.addElement('input', null, li, checkBoxData);
        }

        $('input[type=radio][name=et-maps-date-filter-date]').change(function() {
            maps.map.on('idle', maps.dateFilterPanel.styleLoaded);
            
            maps.map.setStyle(this.value);
        });
    }

    styleLoaded() {
        maps.map.off('idle', maps.dateFilterPanel.styleLoaded);
        maps.layerFilterPanel.applyFilters();
    }
    
    getFilters() {
        if (!maps.filters || !maps.filters.filters || maps.filters.filters.length == 0) {
            return null;
        }
        
        for (let i = 0; i < maps.filters.filters.length; i++) {
            if (maps.filters.filters[i]['filter-type'] == 8) { // Filter type 8.
                return maps.filters.filters[i];
            }
        }

        return null;
    }

    filterButtonClick() {
        $(`#${elementIDs.layerFilterPanel}`).hide();
        $(`#${elementIDs.dateFilterPanel}`).toggle();
    }
}

//-----------------------------------------------------------------------------

// Panel that displayes filter with layers.
class LayerFilterPanel {
    constructor() {
        this.element = document.getElementById(elementIDs.layerFilterPanel);
        
        this.build();
    }
    
    build() {
        // If the element is not defined, hide the filter button.
        if (!this.element) {
            $(`#${elementIDs.layerFilterButton}`).hide();
            return;
        }
        
        // Filters for this map are not available.
        this.defaultStyle = maps.style;
        this.filters = this.getFilters();
        if (!this.filters || !this.filters.options || this.filters.options.length == 0) {
            $(`#${elementIDs.layerFilterButton}`).hide();
            return;
        }
        
        $(`#${elementIDs.layerFilterButton}`).show();
        this.element.innerHTML = '';
        this.addHeader();
        this.addFilters();

        // Hook on the filter button.
        $(document).off('click', `#${elementIDs.layerFilterButton}`).on('click', `#${elementIDs.layerFilterButton}`, this.filterButtonClick);
    }

    show() {
        $(`#${elementIDs.layerFilterPanel}`).show();
    }
    
    hide() {
        $(`#${elementIDs.layerFilterPanel}`).hide();
    }
    
    closeButtonClick(e) {
        maps.layerFilterPanel.hide();
    }

    addHeader() {
        let header = DomHelper.addElement('div', null, this.element, {class: 'et-maps-panel-header'});
        
        DomHelper.addElement('div', maps.i18n.layer_filter_panel_title, header, {class: 'et-maps-panel-header-title'});

        this.closeButton = DomHelper.addElement('div', null, header, {class: 'et-maps-panel-header-close-button'});
        DomHelper.addElement('i', 'close', this.closeButton, {class: 'material-icons'});

        this.closeButton.addEventListener("click", this.closeButtonClick);
    }

    addFilters() {
        let body = DomHelper.addElement('div', null, this.element, {class: 'et-maps-panel-body'});
        let parent = DomHelper.addElement('ul', null, body, {class: 'et-maps-panel-filter-list'});
        for(let i = 0; i < this.filters.options.length; i++) {
            let filter = this.filters.options[i];
            // option-color
            if (filter['option-type'] == 2) {
                let li = DomHelper.addElement('li', null, parent, {class: 'et-maps-panel-filter-list-header'});
                DomHelper.addElement('label', filter["option-title"], li, {
                    for: `et-maps-layer-filter-layer-${i}`,
                    class: 'et-maps-panel-filter-list-layer-label'});
                DomHelper.addElement('input', null, li, {
                    id: `et-maps-layer-filter-layer-${i}`,
                    name: `et-maps-layer-filter-layer-${i}`,
                    type: "checkbox",
                    value: filter["option-value"],
                    'data-option-type': filter['option-type'],
                    checked: 'checked'
                });
            } else {
                let li = DomHelper.addElement('li', null, parent, {class: 'et-maps-panel-filter-list-item'});
                DomHelper.addElement('label', null, li, {
                    for: `et-maps-layer-filter-layer-${i}`,
                    class: 'et-maps-panel-filter-list-color-box',
                    id: filter['option-class-id'],
                    style: `background-color: ${filter["option-color"]}`
                });
                DomHelper.addElement('label', filter["option-title"], li, {
                    for: `et-maps-layer-filter-layer-${i}`,
                    class: 'et-maps-panel-filter-list-layer-label'});
                DomHelper.addElement('input', null, li, {
                    id: `et-maps-layer-filter-layer-${i}`,
                    name: `et-maps-layer-filter-layer-${i}`,
                    type: "checkbox",
                    value: filter["option-value"],
                    'data-option-type': filter['option-type'],
                    checked: 'checked'
                });
            }
        }

        $('input[type=checkbox][name^=et-maps-layer-filter-layer]').change(function() {
            let optionType = $(this).attr('data-option-type');
            let checkState = $(this).prop('checked');
            let value = this.value;
            
            // If header clicked.
            if (optionType == 2) {
                $(this).closest('.et-maps-panel-filter-list-header').nextUntil('.et-maps-panel-filter-list-header').each(function() {
                    $(this).find('input[type=checkbox]').prop('checked', checkState);
                });
            }
            // If item clicked.
            else if (optionType == 3) {
                let header = $(this).closest('.et-maps-panel-filter-list-item').prevAll('.et-maps-panel-filter-list-header:first');
                // Item is unchecked. Check if all siblings are checked. If yes, header item must be checked too.
                if (checkState) {
                    let allChecked = true;
                    header.nextUntil('.et-maps-panel-filter-list-header').each(function() {
                        let isChecked = $(this).find('input[type=checkbox]').prop('checked');
                        if (!isChecked) {
                            allChecked = false;
                        }
                    });

                    if (allChecked) {
                        header.find('input[type=checkbox]').prop('checked', true);
                    }
                }
                // Item is unchecked. Header item must be unchecked too.
                else {
                    header.find('input[type=checkbox]').prop('checked', false);
                }
            }

            let values = value.split(",");
            for (let i = 0; i < values.length; i++) {
                if (checkState) {
                    maps.map.setLayoutProperty(values[i], 'visibility', 'visible');
                } else {
                    maps.map.setLayoutProperty(values[i], 'visibility', 'none');
                }
            }
        });
    }

    getFilters() {
        if (!maps.filters || !maps.filters.filters || maps.filters.filters.length == 0) {
            return null;
        }
        
        for (let i = 0; i < maps.filters.filters.length; i++) {
            if (maps.filters.filters[i]['filter-type'] == 6) { // Filter type 6.
                return maps.filters.filters[i];
            }
        }

        return null;
    }

    // Apply all current filters on the map.
    applyFilters() {
        let appliedLayers = new Set(); // Layers that was changed.
        $('input[type=checkbox][name^=et-maps-layer-filter-layer]').each(function() {
            let isChecked = $(this).prop('checked');
            let values = this.value.split(",");
            for (let i = 0; i < values.length; i++) {
                let layer = maps.map.getLayer(values[i]);
                if (layer && !appliedLayers.has(values[i])) {
                    appliedLayers.add(values[i]);
                    if (isChecked) {
                        maps.map.setLayoutProperty(values[i], 'visibility', 'visible');
                    } else {
                        maps.map.setLayoutProperty(values[i], 'visibility', 'none');
                    }
                }
            }
        });
    }

    filterButtonClick() {
        $(`#${elementIDs.dateFilterPanel}`).hide();
        $(`#${elementIDs.layerFilterPanel}`).toggle();
    }
}

//-----------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function() {
    let mapElement = document.getElementById(elementIDs.map);
    if (mapElement) {
        let i18n = JSON.parse(mapElement.getAttribute('data-language'));
        let accessToken = mapElement.getAttribute('data-access-token');
        let style = mapElement.getAttribute('data-style');
        let apiFeelingTypesUrl = mapElement.getAttribute('data-api-feeling-types-url');
        let apiAddFeelingUrl = mapElement.getAttribute('data-api-add-feeling-url');
        let apiRatingsUrl = mapElement.getAttribute('data-api-get-ratings-url');
        let apiRatingsInfoUrl = mapElement.getAttribute('data-api-get-ratings-info-url');
        let apiAddRatingUrl = mapElement.getAttribute('data-api-add-rating-url');
        let targetImageUrl = mapElement.getAttribute('data-target-image-url');
        let displayPosition = mapElement.getAttribute('data-display-position');
        let properties = mapElement.getAttribute('data-properties');
        let latitude = mapElement.getAttribute('data-latitude');
        let longitude = mapElement.getAttribute('data-longitude');
        
        if (properties) {
            properties = JSON.parse(properties);
        }
        
        let filters = mapElement.getAttribute('data-filters');
        if (filters) {
            filters = JSON.parse(filters);
        }

        mapboxgl.accessToken = accessToken;
        if (!mapboxgl.supported()) {
            mapElement.innerHTML = `
                <div style="display: table;height: 50%;width: 100%">
                    <h1 style="display: table-cell;vertical-align: bottom;text-align:center;width:100%">${i18n.error_unsupported}</h1>
                </div>`;
            return;
        }
        
        let map = new mapboxgl.Map({
            container: elementIDs.map,
            style: style
        });
        
        var nav = new mapboxgl.NavigationControl({
            showCompass: false,
            showZoom: true,
            visualizePitch: false
        });
        map.addControl(nav, 'top-left');

        // disable map rotation using right click + drag
        map.dragRotate.disable();
        // disable map rotation using touch rotation gesture
        map.touchZoomRotate.disableRotation();
        
        // Select specified latitude and longitude. 
        if (latitude && longitude) {
            setTimeout(function() {
                latitude = parseFloat(latitude);
                longitude = parseFloat(longitude);
                let lngLat = new mapboxgl.LngLat(longitude, latitude);
    
                showPositionPopUp(lngLat);
                map.setCenter(lngLat);
            }, 500);
        }
        
        maps = {
            map: map,
            style: style,
            i18n: i18n,
            targetImageUrl: targetImageUrl,
            properties: properties,
            filters: filters,

            apiFeelingTypesUrl: apiFeelingTypesUrl,
            apiAddFeelingUrl: apiAddFeelingUrl,
            apiRatingsUrl: apiRatingsUrl,
            apiRatingsInfoUrl: apiRatingsInfoUrl,
            apiAddRatingUrl: apiAddRatingUrl,
            point: null,
            control: null,
            popup: null,
            displayPosition: displayPosition,

            dateFilterPanel: null,
            layerFilterPanel: null,
            layersPanel: null,
            layerDetailPanel: null
        };

        maps.dateFilterPanel = new DateFilterPanel();
        maps.layerFilterPanel = new LayerFilterPanel();
        maps.layersPanel = new LayersPanel();
        maps.layerDetailPanel = new LayerDetailPanel();
        maps.control = new FeelingWelcomeControl(map);
        
        // Click on the map.
        map.on('click', function(e) {
            let features = maps.map.queryRenderedFeatures(e.point);
            let guidFeatures = LayersPanel.filterKnownFeatures(features);
            if (guidFeatures != null && guidFeatures.length > 0 || (maps.displayPosition != null && maps.displayPosition == 1)) {
                // maps.popup = new mapboxgl.Popup({
                //     anchor: 'center',
                //     className: 'et-maps-position',
                //     offset: [0, 0],
                //     closeButton: false
                // });

                // // Create pop up and handle pop up click to refresh its position.
                // let content = document.createElement('img');
                // content.setAttribute('src', maps.targetImageUrl);
                // content.addEventListener("click", function(e) {
                //     let point = {x: e.x, y: e.y - 100};
                //     let lngLat = map.unproject(point);
                //     maps.popup.setLngLat(lngLat);
                    
                //     refreshCurrentPoint([point.x, point.y], lngLat);
                // });

                // // Show pop up with current target.
                // maps.popup.setLngLat(e.lngLat)
                //     .addTo(map)
                //     .setDOMContent(content);

                showPositionPopUp(e.lngLat);
            } else {
                if (maps.popup != null) {
                    maps.popup.remove();
                }
            }

            refreshCurrentPoint(e.point, e.lngLat);
        });

        $(document).on('click', '.map-showable-point', function () {
            let latitude = parseFloat($(this).attr('data-latitude'));
            let longitude = parseFloat($(this).attr('data-longitude'));
            let lngLat = new mapboxgl.LngLat(longitude, latitude);

            showPositionPopUp(lngLat);
            map.setCenter(lngLat);
        });

        function showPositionPopUp(lngLat) {
            if (maps.popup != null) {
                maps.popup.remove();
            }
            
            maps.popup = new mapboxgl.Popup({
                anchor: 'center',
                className: 'et-maps-position',
                offset: [0, 0],
                closeButton: false
            });

            // Create pop up and handle pop up click to refresh its position.
            let content = document.createElement('img');
            content.setAttribute('src', maps.targetImageUrl);
            content.addEventListener("click", function(e) {
                let point = {x: e.x, y: e.y - 100};
                let lngLat = map.unproject(point);
                maps.popup.setLngLat(lngLat);
                
                refreshCurrentPoint([point.x, point.y], lngLat);
            });

            // Show pop up with current target.
            maps.popup.setLngLat(lngLat)
                .addTo(map)
                .setDOMContent(content);
        }
    }
});
